import { Toaster } from "components/ui/toaster.tsx";
import { Provider } from "react-redux";
import { HashRouter as Router } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { Toaster as Sonner } from "./components/ui/sonner";
import { TooltipProvider } from "./components/ui/tooltip.tsx";
import { GlobalStateProvider } from "./context/GlobalStateContext.jsx";
import "./index.css";
import { ThemeProvider } from "./providers/ThemeProvider";
import AppRoutes from "./routes";
import { persistor, store } from "./store/store.ts";

function App() {
  // const BASENAME = import.meta.env.VITE_ROUTER_BASENAME || "/";

  return (
    <ErrorBoundary>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <GlobalStateProvider>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <ThemeProvider>
                <Router>
                  <div className="min-h-screen transition-colors duration-200">
                    <AppRoutes />
                  </div>
                </Router>
              </ThemeProvider>
            </PersistGate>
          </Provider>
        </GlobalStateProvider>
      </TooltipProvider>
    </ErrorBoundary>
  );
}

export default App;
